module.exports = __webpack_public_path__ + "img/Shaman-tauren-m-70.088ad333.gif";